import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TEquimetre } from '../../shared/types/training.type'
import BaseModal from './BaseModal'
import { t } from 'i18next'
import { setEqmNameModal, setEqmToEdit } from '../../store/reducers/modal.reducer'
import { Box, Button, Stack, TextField } from '@mui/material'
import { useMyEquimetres } from '../../hooks/useMyEquimetres'
import { useAuth } from '../../hooks/useAuth'
import { LoadingButton } from '@mui/lab'
import { TUser } from '../../shared/types/user.type'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'

function EditEqmDisplayNameModal() {

    const open = useSelector<RootState>(state => state.modals.editEqmNameModal) as boolean
    const item = useSelector<RootState>(state => state.modals.eqmToEdit) as TEquimetre | null
    const auth = useSelector<RootState>(state => state.user.user) as TUser
    const dispatch = useDispatch()
    const { updateEqm } = useMyEquimetres({ enableQuery: false, userId: auth?.['@id'] })
    const query = useQueryClient()
    const [display_name, setDisplayName] = useState('')


    const handleClose = () => {
        dispatch(setEqmToEdit(null))
        dispatch(setEqmNameModal(false))
    }


    useEffect(() => {
        if (item) {
            setDisplayName(item?.display_name ?? "")
        }
    }, [item])

    const patchEqm = async () => {
        if (!item) return
        try {
            await updateEqm.mutateAsync({ id: item.id, data: { display_name } })
            toast(t('rights:success'), { type: 'success' })
            handleClose()
            query.refetchQueries('eqms')
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })
        }
    }

    if (!open) return null

    return (
        <BaseModal
            title={t('tracks:information')}
            open={open}
            handleClose={handleClose}
        >
            <Stack direction={'column'} spacing={2}>
                <TextField value={display_name} onChange={e => setDisplayName(e.target.value)} label={t('equimetre:table:name')} placeholder={t('equimetre:table:name')} />

                <Box display={'flex'} justifyContent={'end'} gap={2} alignItems={'center'}>
                    <Button onClick={handleClose} disabled={updateEqm.isLoading}>{t('button:cancel')}</Button>
                    <LoadingButton onClick={patchEqm} loading={updateEqm.isLoading} variant='contained'>{t('button:save')}</LoadingButton>

                </Box>
            </Stack>
        </BaseModal >
    )
}

export default EditEqmDisplayNameModal